export default "__VITE_ASSET__CFrhiJfp__"